
export const getDefaultBrush = () => {
    let brush = {
        toolbox: [],
        throttleType: 'debounce',
        xAxisIndex: 'all'
    }
    return brush;
}

export const getLineXBrush = () => {
    let brush = {
        type: ['lineX', 'clear'],
        throttleType: 'debounce',
        xAxisIndex: 'all'
    }
    return brush;
}



export const getNoiseAnalysisLineXBrush = () => {
    let brush = {
        toolbox: ['lineX', 'clear'],
        xAxisIndex: 0,
        brushLink: 0,
        outOfBrush: {  //定义 在选中范围外 的视觉元素
            colorAlpha: 0.1
        },
        throttleType: 'debounce',
        throttleDelay: 1000
    }
    return brush;
}
